export const environment = {
    PRODUCTION: true,
    API_URL: 'https://api.freddiemed.com/api/v1/patient-portal/',
};
